import React from 'react';

function TableHeader() {
    return (
        <div className={'section__row section__header'}>
            <div className={'section__cell section__cell--name'}>
                <span>Service</span>
            </div>
            <div className={'section__cell section__cell--sites hide-tablet'}>
                <span>Units</span>
            </div>
            <div className={'section__cell section__cell--per-site hide-tablet'}>
                <span>Cost per unit/year</span>
            </div>
            <div className={'section__cell section__cell--sum hide-tablet'}>
                <span>Sum</span>
            </div>
        </div>
    );
}

export default TableHeader;
